var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.temporaryProducts)?_c('div',{staticClass:"selected-products"},[_vm._l((_vm.temporaryProducts),function(product){return _c('div',[_c('modal',{attrs:{"result":product}})],1)}),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.noneSelected),expression:"noneSelected"}]},[_vm._v("None Selected")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }